<template>
  <div id="user-top-mobile" class="hidden-lg hidden-md element-user-top-mobile">

    <btn class="dropdown-toggle dropdown-toggle-login hidden-md hidden-lg" style="border-style: none;"
         @click="toggleMenu()">
      <img src="https://static.pizzahut.jp/jp/icons/inactive@2x.png" width="22">
    </btn>
    <a href="/home" class="logo">
      <img src="https://static.pizzahut.jp/jp/logos/ph-logo-horizontal%402x.png"/>
    </a>
    <div class="box-right hidden-lg hidden-md">
      <div class="hut-rewards--flat-button mr-0">
        <a href="javascript: void(0)" @click="redirectTo('category', {slug: $const.HEADER_MENU.COUPON})">
          <img v-if="$i18n.locale == $const.LANG_JP" src="../../assets/images/icons/icon-coupons-jp-2x.png" alt="Coupons" title="Coupons"
               class="img-track" width="25" style="width: 60px ">
          <img v-else src="../../assets/images/icons/icon-coupons-2x.png" alt="Coupons" title="Coupons"
               class="img-track" width="25" style="width: 60px ">
        </a>
      </div>

      <div class="login-box ">
        <router-link to="/order" class="cart" style="border: none">
          <img src="../../assets/images/icons/cart.png" alt="Track Order" title="Track Order"
               class="img-cart">
          <span v-if="amount > 0" class="num-cart num-cart-mobile">
          {{amount}}
        </span>
        </router-link>
      </div>
    </div>

    <div class="t13 text-black disposition-info">
      <a class="close-sidebar hidden-md hidden-lg"
         @click.prevent.stop="toggleMenu()">
        <img src="https://static.pizzahut.jp/jp/icons/close-sidebar.png"
             class="">
      </a>

      <div class="item user-box">
        <div class="login-logo">
          <img v-if="!$auth.check()" src="https://static.pizzahut.jp/jp/icons/inactive@2x.png" class="" width="22">
          <img src="https://static.pizzahut.jp/jp/icons/active@2x.png" width="23" v-else>
        </div>
        <div class="login-box">
          <span class="logged" v-if="$auth.check() ">
            <router-link v-if="$i18n.locale == $const.LANG_JP" to="/profile" style="line-height: 32px; white-space: normal !important;">{{$t('full_name_format', {last_name:$auth.user().last_name})}}</router-link>
            <router-link v-else to="/profile" style="line-height: 32px; white-space: normal !important;">{{$t('full_name_format', {first_name:$auth.user().first_name, last_name:$auth.user().last_name})}}</router-link>
          </span>
          <router-link v-else to="/login">
            {{ $t("login_title") }}
          </router-link>

          <span class="hidden-sm hidden-xs">/</span>

          <router-link v-if="!$auth.check()"
                       to="/register">{{ $t("login_register")}}</router-link>
          <a v-else
             v-on:click="$root.$emit('logout')"
             class="router-link-active logout">{{ $t("button_logout")}}</a>
        </div>
      </div>
      <div>
          <div class="p-5">
            <a @click="changeLang('ja')" role="button" class="decoration-none">
              <img src="../../assets/images/icons/jp.png" class="xs-mr-5 border-radius-4" width="35" style="width: 35px !important;">日本語
              <span class="pull-right" v-if="$i18n.locale == $const.LANG_JP"><img src="../../assets/images/icons/path@2x.png"></span>
            </a>
          </div>
        <hr class="mt-5 mb-5"/>
          <div class="p-5">
            <a role="button" @click="changeLang('en')" class="decoration-none">
              <img src="../../assets/images/icons/en.png" class="xs-mr-5 border-radius-4" width="30" style="width: 35px !important;">English
              <span class="pull-right" v-if="$i18n.locale != $const.LANG_JP"><img src="../../assets/images/icons/path@2x.png"></span>
            </a>
          </div>
      </div>
    </div>
    <div class="overlay-bg z-100"></div>
  </div>
</template>
<style scoped>

  .line-h-30 {
    line-height: 40px;
    padding-left: 10px;
  }
  .min-width-100 {
    min-width: 100px;
  }
  .element-user-top-mobile .disposition-info div img {
    filter: none !important;
  }
  .element-user-top-mobile .info-box {
    display: flex;
    align-items: center;
  }
  .element-user-top-mobile .info-box .login-box a {
    color: #000;
  }

  #user-top-mobile {
    position: relative;
    right: 0;
    min-width: 80px;
    z-index: 1;
    background-color: #fff;
  }

  #user-top-mobile.hide-top {
    position: absolute !important;
    z-index: 1 !important;
  }

  .login-logo {
    text-align: center;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .login-box {
    position: absolute;
    top: 44px;
    right: 0;
    width: 100px;
    line-height: 40px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    z-index: 99;
    box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, .15);
    padding-left: 0px;
  }

  .login-box a, .login-box span, .login-box button {
    text-decoration: none;
    color: #333;
    font-weight: 600;
  }
  .element-user-top-mobile a.logo {
    left: 50% !important;
    margin-left: -25px !important;
    position: absolute !important;
  }
  .element-user-top-mobile a.logo img {
    width: 27% !important;
  }
  .element-user-top-mobile .disposition-info {
    display: none !important;
  }
  @media (max-width: 992px) {
    a.close-sidebar {
      position: fixed;
      top: 10px;
      right: 10px;
      width: 25px;
    }
    body.toggle .overlay-bg {
      display: block;
    }
    .element-user-top-mobile .disposition-info {
      position: fixed;
      top: 0;
      left: 0;
      background: white;
      width: 280px;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      height: 100%;
      z-index: 999;
      padding: 0 15px;
    }
    .toggle .element-user-top-mobile .disposition-info {
      display: block !important;
    }
    .login-box {
      margin: 0;
      right: 0 !important;
      padding: 5px !important;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }
    .login-box .logout {
      font-size: 14px !important;
      margin-left: 5px;
      font-weight: bold;
      border-left: 1px solid #98A0A6;
      padding-left: 5px;
      height: 25px;
      -ms-flex-item-align: center;
      align-self: center;
    }
    .login-box a {
      border-bottom: none;
      font-size: 17px;
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      text-transform: uppercase;
      padding-bottom: 0 !important;
    }
    .disposition-info .item.user-box {
      margin: 30px 0px 50px;
      border-top: none !important;
    }
  }
</style>
<script>
  import * as types from '@/store/types'
  import UserTopMobile from '../partials/UserTopMobile'
  import UserTopDesktop from '../partials/UserTopDesktop'
  import {
    mapGetters,
    mapActions
  } from 'vuex'

  export default {
    components: {
      UserTopMobile,
      UserTopDesktop
    },
    mounted: function () {
      this.$cart.init(this)
      var vm = this
      this.$root.$on('cartUpdate', () => {
        vm.$cart.init(vm)
        vm.amount = vm.getTotalCartItem(vm.cart)
      })
      vm.amount = this.getTotalCartItem(this.cart)

      // hide-top
    },
    destroyed () {
      this.$root.$off('cartUpdate')
    },
    data() {
      return {
        flag: false,
        amount: 0
      }
    },
    methods: {
      ...mapActions({
        setHomeSidebarOpen: types.SET_HOME_SIDEBAR_OPEN
      }),
      toggleMenu () {
        this.setHomeSidebarOpen()
      },
      toggleLogin() {
        this.flag = !this.flag
      },
      logout: function () {
        this.$auth.logout({
          data: {
            token: this.$auth.user().token
          },
          success: function (response) {
            if (response.data.status) {
              this.$router.push('/')
            } else {
              main.$notify({
                type: 'Error',
                title: response.data.error.msg
              })
            }
          },
          error: function (data) {
            main.$notify({
              type: 'Error',
              title: this.$t('message_logout_error')
            })
          }
        })
      },
      changeLang(la) {
        this.lang = la
        this.$store.dispatch('setLang', la)
        this.$session.set('lang', la)
        this.$router.go(this.$router.currentRoute)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/home/HomeUserTopMobile.vue